import { format, isToday, isYesterday, differenceInMinutes } from 'date-fns';

export function listTime(iso: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (isToday(d)) return format(d, 'HH:mm');
  if (isYesterday(d)) return 'Yesterday';
  return format(d, 'dd MMM');
}

export function dayLabel(d: Date): string {
  if (isToday(d)) return 'Today';
  if (isYesterday(d)) return 'Yesterday';
  return format(d, 'EEEE, d MMMM');
}

export function windowState(until: string | null): { open: boolean; label: string } {
  if (!until) return { open: false, label: 'No customer message yet' };
  const mins = differenceInMinutes(new Date(until), new Date());
  if (mins <= 0) return { open: false, label: '24h window closed' };
  if (mins < 60) return { open: true, label: `Window closes in ${mins}m` };
  return { open: true, label: `Window open · ${Math.floor(mins / 60)}h left` };
}

export const INTENT_LABEL: Record<string, { label: string; variant: 'success' | 'secondary' | 'destructive' | 'warning' | 'muted' }> = {
  order: { label: 'Order', variant: 'success' },
  inquiry: { label: 'Question', variant: 'secondary' },
  complaint: { label: 'Complaint', variant: 'destructive' },
  feedback: { label: 'Feedback', variant: 'warning' },
  other: { label: 'Other', variant: 'muted' },
};
